import { render, staticRenderFns } from "./spec-picker-modal.vue?vue&type=template&id=3c6adb8e&scoped=true"
import script from "./spec-picker-modal.vue?vue&type=script&lang=js"
export * from "./spec-picker-modal.vue?vue&type=script&lang=js"
import style0 from "./spec-picker-modal.vue?vue&type=style&index=0&id=3c6adb8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6adb8e",
  null
  
)

export default component.exports